import type { LayoutBlock } from '@web-studio/shared-schemas';
import { addressMapBlockDefault } from '../blocks/addressMap';
import { liveBakeryCounterListDefault } from '../blocks/bakeryCounter';
import { footerStandardDefault } from '../blocks/footer';
import { heroCafeSpotlightDefault } from '../blocks/heroVerticals';
import { navigationCafeDefault } from '../blocks/navigationVerticals';
import { simpleOpeningHoursDefault } from '../blocks/openingHours';
import { socialFeedGridDefault } from '../blocks/socialFeed';

/** Cafe / recommended — marketplace & design-lab preview. */
export const cafeRecommendedPage: LayoutBlock[] = [
  { ...navigationCafeDefault, displayOrder: 0 },
  { ...heroCafeSpotlightDefault, displayOrder: 1 },
  { ...simpleOpeningHoursDefault, displayOrder: 2 },
  { ...addressMapBlockDefault, displayOrder: 3 },
  { ...liveBakeryCounterListDefault, displayOrder: 4 },
  { ...socialFeedGridDefault, displayOrder: 5 },
  { ...footerStandardDefault, displayOrder: 99 },
];
